import StockPhotoCredit from '@/components/StockPhotoCredit';
import { toStockAttribution, type ImageMeta } from '@/lib/imageAttribution';

/**
 * Stock-photo credit for a homepage section's background image.
 *
 * Homepage images are full-bleed backgrounds, so the credit is a small corner
 * overlay rather than the figcaption-below that blog posts use. Renders
 * nothing unless the image actually came from a stock library with a known
 * photographer — AI renders, brand gradients, the property's own photos and
 * hand-uploaded images owe no credit.
 */
export default function SectionPhotoCredit({ content }: { content?: { image_meta?: ImageMeta } }) {
  const attribution = toStockAttribution(content?.image_meta);
  if (!attribution) return null;

  return (
    <StockPhotoCredit
      attribution={attribution}
      className="pointer-events-auto absolute bottom-1 right-2 z-10 text-[10px] leading-tight text-white/70 [text-shadow:0_1px_3px_rgba(0,0,0,0.6)]"
    />
  );
}
